import { filter, sumBy } from 'lodash'

const nonNotApplicable = (statuses) => filter(statuses, (status) => status.color != 'grey')

const sortCoverageSummary = (a, b) => {
  const aPercentageCovered = (sumBy(filter(a, ['color', 'green']), 'count') / sumBy(nonNotApplicable(a), 'count')) * 100
  const bPercentageCovered = (sumBy(filter(b, ['color', 'green']), 'count') / sumBy(nonNotApplicable(b), 'count')) * 100

  if (aPercentageCovered === bPercentageCovered) { return 0 }
  return aPercentageCovered > bPercentageCovered ? 1 : -1
}

export { nonNotApplicable, sortCoverageSummary }